module.exports = __webpack_public_path__ + "static/media/bg_page_08.0ce378c8.jpg";